module.exports = __webpack_public_path__ + "static/media/21ECLAC28.5ab0243a.jpg";